import React from 'react'
import {Form, Button, Col, Spinner} from 'react-bootstrap';
import {Field, Formik} from "formik";
import ErrorArea from "../../../../ui/forms/ErrorArea";
import {Input} from "../../../../ui/forms/formik";
import {userSignUp} from "../../../../../store/actions/AuthActions/SignUpActions";
import {connect} from "react-redux";
import {resetPasswordSchema} from "./ResetPasswordSchema";
import {userResetPassword} from "../../../../../store/actions/AuthActions/ResetPasswordActions";


const ResetPasswordForm = (props) => {
    const signUpText = "Reset Password";

    const {resetPassword, isSubmitting, errors} = props;
    const {USER_RESET_PASSWORD_GENERAL_ERROR: generalError} = errors;

    return (
        <Formik
            initialValues={{}}
            validationSchema={resetPasswordSchema}
            onSubmit={(values, actions) => resetPassword(values)}
            validateOnMount>
            {({
                  handleSubmit,
                  isValid,
                  dirty
              }) => (
                <Form className="formik submit-form-step" onSubmit={handleSubmit}>
                    <Form.Row className="form--row">
                        <Col xs={12} className="form--col">
                            <Field
                                name="password"
                                type="password"
                                placeholder="Password"
                                component={ResetPasswordForm.Input}
                                className="input input-flat input-xl password"

                            />
                        </Col>
                    </Form.Row>

                    <Form.Row className="form--row">
                        <Col xs={12} className="form--col">
                            <Field
                                name="confirmPassword"
                                type="password"
                                placeholder="Confirm Password"
                                component={ResetPasswordForm.Input}
                                className="input input-flat input-xl confirm-password"
                            />
                        </Col>
                    </Form.Row>

                    {
                        generalError &&
                        <Form.Row className="form--row error-message">
                            <Col xs={12} className="form--col">
                                <ErrorArea message={generalError}/>
                            </Col>
                        </Form.Row>
                    }

                    <Form.Row className="form--row">
                        <Col className="form--col">
                            <Button className="submit" type="submit" variant="primary" size="xl" disabled={isSubmitting || !isValid} block>
                                <div className="d-flex justify-content-center align-content-center align-items-center">
                                    {isSubmitting && <Spinner className="spinner" animation="border" variant="primary"/>}
                                    <span className="mr-2"> {signUpText} </span>
                                </div>
                            </Button>
                        </Col>
                    </Form.Row>
                </Form>
            )}
        </Formik>
    );
};

ResetPasswordForm.Input = props => <Input errorMessagePosition="left-bottom" withoutMargin {...props}/>;


const mapStateToProps = state => {
    return {
        /**
         *
         */
        signedUp: state.auth.resetPassword.success,

        /**
         * Signing up
         */
        isSubmitting: state.auth.resetPassword.loading,


        /**
         * Signing up errors
         */
        errors: state.auth.errors.resetPassword,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        /**
         * Signing up using user data.
         * @param user {object} The entered information of user.
         * @returns {Promise} The axsios promise.
         */

        resetPassword: (user) => dispatch(userResetPassword(user)).then(() => window.location.href = '/dashboard'),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);
